import { confidenceBucket } from '../../lib/periodFormat';

/**
 * makePeriodoFilters(filters, krById) — costruisce le 3 funzioni predicato
 * per filtrare KR, Azioni e MIT in base ai filtri trasversali (area/stato/confidence).
 *
 * Ritorna anche `toggleAreaChip(filters, setFilters, area)` come helper UI.
 *
 * Nota: ho mantenuto la stessa semantica del file originale (in particolare
 * la regola "MIT senza KR non passa il filtro area").
 */
export function makePeriodoFilters(filters, krById) {
  const krPassesFilters = (kr) => {
    if (!kr) return filters.area.length === 0 && filters.stato.length === 0 && filters.confidence.length === 0;
    if (filters.area.length > 0) {
      const a = (kr.area || '').toLowerCase();
      if (!filters.area.includes(a)) return false;
    }
    if (filters.confidence.length > 0) {
      const b = confidenceBucket(kr.confidence);
      if (!b || !filters.confidence.includes(b)) return false;
    }
    if (filters.stato.length > 0) {
      const isRaggiunto = kr.stato === 'raggiunto';
      const b = confidenceBucket(kr.confidence);
      const isARischio = b === 'bassa';
      const isOnTrack = !isRaggiunto && !isARischio;
      const match = filters.stato.some((s) => (
        (s === 'raggiunto' && isRaggiunto)
        || (s === 'a_rischio' && isARischio)
        || (s === 'on_track' && isOnTrack)
      ));
      if (!match) return false;
    }
    return true;
  };

  const azionePassesFilters = (a) => {
    const kr = a.key_result_id ? krById[a.key_result_id] : null;
    if (filters.area.length > 0) {
      const ar = ((a.area || kr?.area) || '').toLowerCase();
      if (!filters.area.includes(ar)) return false;
    }
    if (filters.stato.length > 0) {
      const isRaggiunto = !!a.fatto;
      const isOnTrack = !a.fatto;
      const match = filters.stato.some((s) => (
        (s === 'raggiunto' && isRaggiunto) || (s === 'on_track' && isOnTrack)
      ));
      if (!match) return false;
    }
    if (filters.confidence.length > 0 && kr) {
      const b = confidenceBucket(kr.confidence);
      if (!b || !filters.confidence.includes(b)) return false;
    }
    return true;
  };

  const mitPassesFilters = (m) => {
    const kr = m.key_result_id ? krById[m.key_result_id] : null;
    if (filters.area.length > 0) {
      if (!kr) return false; // MIT senza KR non passa il filtro area
      const ar = (kr.area || '').toLowerCase();
      if (!filters.area.includes(ar)) return false;
    }
    if (filters.stato.length > 0) {
      const isRaggiunto = !!m.fatto;
      const isOnTrack = !m.fatto;
      const match = filters.stato.some((s) => (
        (s === 'raggiunto' && isRaggiunto) || (s === 'on_track' && isOnTrack)
      ));
      if (!match) return false;
    }
    if (filters.confidence.length > 0 && kr) {
      const b = confidenceBucket(kr.confidence);
      if (!b || !filters.confidence.includes(b)) return false;
    }
    return true;
  };

  return { krPassesFilters, azionePassesFilters, mitPassesFilters };
}

/** Toggle del chip "area" nella sidebar dei filtri. */
export function makeToggleAreaChip(filters, setFilters) {
  return (area) => {
    const cur = filters.area || [];
    setFilters({
      ...filters,
      area: cur.includes(area) ? cur.filter((a) => a !== area) : [...cur, area],
    });
  };
}
